module.exports = "<svg viewBox=\"0 0 24 24\"><path d=\"M9.6,14L12,7.7L14.4,14M11,5L5.5,19H7.7L8.8,16H15L16.1,19H18.3L13,5H11Z\"></path></svg>"